import React from "react";
import { FormattedMessage } from "react-intl";
import { Row, Space } from "@masterteam/mt-design-react";

import DashboardCard from "../DashboardCard";

import { ReactComponent as LevelOneIcon } from "../../../assets/images/level-one.svg";

import "./style.scss";

const StrategicObjectives = ({ data, kpiStatuses, projectStatuses }) => {
  return (
    <Space className="strategic-objectives-wrapper" direction="vertical">
      <Row
        className="strategic-objectives-wrapper__header"
        align="center"
        size="small"
        style={{ backgroundColor: `${data?.Color}25`, color: data?.Color }}
      >
        <LevelOneIcon fill={data?.Color} />
        <FormattedMessage id="strategic-objectives" />
      </Row>

      {data?.Objectives?.length ? (
        <div className="strategic-objectives-wrapper__cards">
          {data?.Objectives?.map((e) => (
            <DashboardCard
              data={e}
              kpiStatuses={kpiStatuses}
              projectStatuses={projectStatuses}
              key={e.ID}
              width="100%"
            />
          ))}
        </div>
      ) : (
        <Row
          justify="center"
          align="center"
          style={{ paddingTop: "16px", fontSize: "14px" }}
        >
          <FormattedMessage id="no-data" />
        </Row>
      )}
    </Space>
  );
};

export default StrategicObjectives;
